import React from "react";
import MailchimpSubscribe from "react-mailchimp-subscribe";

const CustomForm = ({ status, message, onValidated }) => {
  let email;
  const submit = () =>
    email &&
    email.value.indexOf("@") > -1 &&
    onValidated({
      EMAIL: email.value,
    });

  if (status === "success") {
    return <h3 className="title" style={{ color: "white" }}>Merci pour votre abonnement !</h3>;
  }

  return (
    <>
      <form onSubmit={(e) => { e.preventDefault(); submit(); }}>
        <input
          ref={node => (email = node)}
          type="email"
          placeholder="Entrez votre email..."
          required
        />
        <button type="submit" className="btn">S'abonner</button>
      </form>
      {status === "sending" && <div style={{ color: "white" }}>Envoi en cours...</div>}
      {status === "error" && <div style={{ color: "red" }} dangerouslySetInnerHTML={{ __html: message }} />}
    </>
  );
};

function Newsletter() {
  const url = process.env.REACT_APP_MAILCHIMP_URL;

  return (
    <div className="newsletter-area pb-110 pt-110">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="newsletter-wrap">
              <div className="newsletter-content">
                <h2 className="title">Newsletter</h2>
                <p><span>*</span> Nous ne partageons pas votre email.</p>
              </div>
              <div className="newsletter-form">
                <MailchimpSubscribe
                  url={url}
                  render={({ subscribe, status, message }) => (
                    <CustomForm
                      status={status}
                      message={message}
                      onValidated={formData => subscribe(formData)}
                    />
                  )}
                />
              </div>
              <div className="newsletter-shape"><img src="img/images/newsletter_shape01.png" alt="" /></div>
              <div className="newsletter-shape shape-two"><img src="img/images/newsletter_shape02.png" alt="" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Newsletter